asciiSize